module.exports = __webpack_public_path__ + "media/reskin-images/icon--users-695b3d17.svg";